<template>
  <div :class="$style.wrapper">
    <div :class="$style.header">
      <img
        :class="this.$store.state.admin ? $style.logoColor : null"
        src="../assets/img/logo.svg"
        alt=""
        @click="toggleMode"
      />
      <div :class="$style.search">
        <img src="../assets/img/search.svg" alt="" />
        <input v-model="search" type="text" placeholder="Поиск" />
      </div>
    </div>
    <div :class="$style.filter">
      <button
        v-for="(button, index) in buttons"
        :key="button"
        @click="changeCategory(index)"
        :class="button.active ? $style.active : null"
      >
        {{ button.title }}
      </button>
    </div>
    <div :class="$style.catalog">
      <Catalog :objects="searchProducts" />
    </div>
  </div>
</template>

<script>
import Catalog from '../components/Catalog.vue';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      search: '',
      activeCategory: [],
      categories: {
        all: [],
        newBuildings: [],
        secondary: [],
        commercial: [],
        country: [],
        rent: [],
        city: [],
      },
      buttons: [
        {
          title: 'Все',
          active: true,
          category: 'all',
        },
        {
          title: 'Новостройки',
          active: false,
          category: 'newBuildings',
        },
        {
          title: 'Вторичные',
          active: false,
          category: 'secondary',
        },
        {
          title: 'Коммерция',
          active: false,
          category: 'commercial',
        },
        {
          title: 'Загородная',
          active: false,
          category: 'country',
        },
        {
          title: 'Аренда',
          active: false,
          category: 'rent',
        },
        {
          title: 'Сити',
          active: false,
          category: 'city',
        },
      ],
    };
  },
  components: {
    Catalog,
  },
  async mounted() {
    window.Telegram.WebApp.ready();
    this.$store.commit('changeLoading', true);
    await this.$store.dispatch('checkInitData', {
      _auth: window.Telegram.WebApp.initData,
    });
    await this.$store.dispatch('getObjects');

    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get('category') || localStorage.getItem('activeCategory');

    if (category) {
      this.selectCategoryByName(category);
    } else {
      this.activeCategory = this.categories.all;
    }

    this.$store.commit('changeLoading', false);
  },
  methods: {
    async toggleMode() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
      if (this.$store.state.user.id) {
        await this.$store.dispatch('checkAdminStatus', this.$store.state.user.id);
      }
      if (this.$store.state.isAdmin) {
        this.$store.commit('toggleAdmin');
      }
    },
    filterObjects() {
      this.categories.all = [];
      this.categories.newBuildings = [];
      this.categories.secondary = [];
      this.categories.commercial = [];
      this.categories.country = [];
      this.categories.rent = [];
      this.categories.city = [];

      this.sortObjects(this.objects);
      for (let i = 0; i < this.buttons.length; i++) {
        if (this.buttons[i].active) {
          this.changeCategory(i);
        }
      }
    },
    sortObjects(objects) {
      for (let i = 0; i < objects.length; i++) {
        switch (objects[i].category) {
          case 'Новостройки':
            this.categories.newBuildings.push(objects[i]);
            break;
          case 'Вторичные':
            this.categories.secondary.push(objects[i]);
            break;
          case 'Коммерция':
            this.categories.commercial.push(objects[i]);
            break;
          case 'Загородная':
            this.categories.country.push(objects[i]);
            break;
          case 'Аренда':
            this.categories.rent.push(objects[i]);
            break;
          case 'Сити':
            this.categories.city.push(objects[i]);
            break;
        }
      }
      this.categories.all = [
        ...this.categories.newBuildings,
        ...this.categories.secondary,
        ...this.categories.commercial,
        ...this.categories.country,
        ...this.categories.rent,
        ...this.categories.city,
      ];
    },
    changeCategory(index) {
      this.buttons.forEach((button, i) => {
        button.active = i === index;
      });
      this.activeCategory = this.categories[this.buttons[index].category];

      localStorage.setItem('activeCategory', this.buttons[index].category);

      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },

    selectCategoryByName(categoryName) {
      const index = this.buttons.findIndex((button) => button.category === categoryName);
      if (index !== -1) {
        this.changeCategory(index);
      }
    },
  },
  computed: {
    searchProducts() {
      return this.activeCategory.filter((p) => {
        return p.header.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
      });
    },
    ...mapState(['objects', 'admin']),
  },
  watch: {
    objects() {
      this.filterObjects();
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
}

.wrapper {
  padding: 16px 0;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    opacity: 100%;
    animation-name: show;
    animation-duration: 1s;
    .logoColor {
      filter: contrast(0);
      transition: all 0.2s ease;
    }
    img {
      filter: contrast(1);
      margin: 0 16px 0 0;
      transition: all 0.2s ease;
    }
    .search {
      display: flex;
      align-items: center;
      width: 100%;
      background-color: $bg-light;
      border-radius: 24px;
      padding: 0 16px;
      img {
        margin-right: 16px;
      }
      input {
        color: $black;
        font-size: 14px;
        background-color: transparent;
        padding: 14px 0;
        border: none;
        outline: none;
      }
    }
  }
  .filter {
    display: flex;
    padding: 16px 0 16px 16px;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    opacity: 100%;
    animation-name: show;
    animation-duration: 1s;
    &::-webkit-scrollbar {
      display: none;
    }
    button {
      background-color: $bg-dark;
      border-radius: 12px;
      border: none;
      outline: none;
      color: $primary;
      padding: 6px 12px;
      margin-right: 8px;
      cursor: pointer;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 10px;
      letter-spacing: 1px;
      transition: all 0.2s ease-in-out;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        transition: all 0.2s ease-in-out;
        background-color: $primary;
        color: $black;
      }
    }
  }
  .catalog {
    padding: 0 16px;
  }
}
</style>
